import React from "react"
import {Tabs} from "antd"
import {useTranslation} from "react-i18next"
import {TabHeader} from "components/Tab"
import {useActiveTab} from "hooks"
import {SapAlert} from "sections/academics/sap/SapAlert"
import SapChecksList from "./parts/SapChecksList"

const {TabPane} = Tabs

export enum RegistrarSapTab {
    Checks = "checks",
    Alerts = "alerts"
}

type Props = {
    departmentId: number
}

export default function RegistrarSap({departmentId}: Props) {
    const {t} = useTranslation(["academics"])
    const [activeTabKey, onChangeTab] = useActiveTab(RegistrarSapTab.Checks, "sapTab")

    return (
        <Tabs className="fullwidth klassSubTab" activeKey={activeTabKey} onChange={onChangeTab}>
            <TabPane tab={<TabHeader title={t("academics.sapChecks.tab")} />} key={RegistrarSapTab.Checks}>
                {activeTabKey === RegistrarSapTab.Checks ? <SapChecksList /> : null}
            </TabPane>
            <TabPane tab={<TabHeader title={t("registrar.sapAlerts")} />} key={RegistrarSapTab.Alerts}>
                {activeTabKey === RegistrarSapTab.Alerts ? <SapAlert departmentId={departmentId} /> : null}
            </TabPane>
        </Tabs>
    )
}
